var _path, _path2, _path3, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo24Px({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info-24px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_508",
    "data-name": "Path 508",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_509",
    "data-name": "Path 509",
    d: "M12,4a8,8,0,1,1-8,8,8.024,8.024,0,0,1,8-8m0-2A10,10,0,1,0,22,12,10.029,10.029,0,0,0,12,2Z",
    fill: "#85878b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_510",
    "data-name": "Path 510",
    d: "M12,10h0a.945.945,0,0,0-1,1v5a.945.945,0,0,0,1,1h0a.945.945,0,0,0,1-1V11A.945.945,0,0,0,12,10Z",
    fill: "#85878b"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_137",
    "data-name": "Ellipse 137",
    cx: 1.3,
    cy: 1.3,
    r: 1.3,
    transform: "translate(10.7 6.4)",
    fill: "#85878b"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo24Px);
export default __webpack_public_path__ + "static/media/info-24px.08ccc187.svg";
export { ForwardRef as ReactComponent };